module.exports = __webpack_public_path__ + "img/logo_animod_dark2x.dd02a8ce.png";